var _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCustomerCare(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7818_41314)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47.3219,
    height: 47.3219,
    rx: 23.6609,
    fill: "#D7DAC5"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: -8.67245,
    y: -14.918,
    width: 50,
    height: 50,
    rx: 25,
    transform: "rotate(26.3745 -8.67245 -14.918)",
    fill: "#666666"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_7818_41314)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.6331 23.9172C38.6336 22.0307 37.3497 20.3862 35.5192 19.9295C35.53 19.8916 35.536 19.8525 35.5372 19.8131C35.2666 13.4838 30.0568 8.49219 23.722 8.49219C17.3873 8.49219 12.1775 13.4838 11.9068 19.8131C11.9081 19.8525 11.9141 19.8916 11.9249 19.9295C10.0066 20.4118 8.70304 22.1914 8.8218 24.166C8.94055 26.1403 10.4479 27.7509 12.4102 27.9997C12.5809 28.0202 12.7524 28.0305 12.9244 28.0305H13.9527V19.8038H12.9387C13.2355 14.0645 17.9752 9.56347 23.722 9.56347C29.4688 9.56347 34.2086 14.0645 34.5054 19.8038H33.4913V28.0305H34.5197V29.5731C34.5197 33.6767 31.2042 36.7715 26.8071 36.7715C26.777 36.7745 26.7471 36.7805 26.7182 36.7893C26.4754 36.0746 25.7509 35.6407 25.0062 35.7637C24.2613 35.8868 23.715 36.5307 23.715 37.2857C23.715 38.0404 24.2613 38.6843 25.0062 38.8076C25.7509 38.9306 26.4754 38.4965 26.7182 37.7818C26.7471 37.7906 26.777 37.7966 26.8071 37.7998C31.7899 37.7998 35.548 34.2634 35.548 29.5731V28.0305C35.5453 27.9846 35.5362 27.9392 35.5207 27.8957C37.3542 27.4501 38.6419 25.8039 38.6331 23.9172V23.9172Z",
    fill: "#333333"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7818_41314"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47.3219,
    height: 47.3219,
    rx: 23.6609,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_7818_41314"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30.3359,
    height: 30.3359,
    fill: "white",
    transform: "translate(8.49316 8.49219)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerCare);
export default __webpack_public_path__ + "static/media/customer_care.b10ac68d23c3db857d4f6969c1511b71.svg";
export { ForwardRef as ReactComponent };